<script setup lang="ts">
// Resolve the boot theme once, as early as the root renders. `initTheme` is
// idempotent and honours a runtime-config `dataTheme` already written to <html>
// by stores/config.applyThemeTokens() (that wins); otherwise it falls back to
// the user's persisted choice, then the OS `prefers-color-scheme`.
import { useTheme } from '@/composables/useTheme';
import { ToastHost } from '@/components/ui';

useTheme().initTheme();
</script>

<template>
  <RouterView />
  <!-- Single app-root toast surface; screens raise toasts via useToast(). -->
  <ToastHost />
</template>
